import { PasswordErrors } from '../../models';
import { FormState } from './types';

export const isSubmitDisabled = (form: FormState, errors?: PasswordErrors): boolean => {
  if (errors) {
    const errorValues = Object.values(errors);

    if (errorValues.some((value) => !value)) {
      return true;
    }
  }

  const formValues = Object.values(form);
  return formValues.some((value) => !value);
};
